module.exports = __webpack_public_path__ + "img/paymentBadgeLockV2.14b77b4.png";